export const endpoints = {
  posts: 'posts',
  fullPosts: 'fullPosts',
  shortPosts: 'shortPosts',
  shortPostsTop: 'shortPosts/top',
  shortPostsAdmin: 'shortPosts/admin',

  postBlock: 'post_blocks',
  postImage: 'post/image',

  users: 'users',
  login: 'admin/login',
  checkToken: 'admin/checkToken',
  logout: 'admin/logout',
};
